module.exports = __webpack_public_path__ + "static/media/radio.171a6c99.png";